import React from 'react';
import {gap} from '../constants';
import LetterSvg from './LetterSvg';

const LetterBox = React.forwardRef(({xpos, ypos, letter, collected, used, transition, className}, ref) => {
    const letterStyle = {
        top: ypos * gap + 'px',
        left: xpos * gap + 'px',
        transition,
    };
    return (
        <div
            className={`letter-box ${collected ? 'collected' : ''} ${used ? 'used' : ''} ${className}`}
            data-xpos={xpos}
            data-ypos={ypos}
            style={letterStyle}
            ref={ref}
        >
            <LetterSvg letter={letter} color={collected || used ? 'white' : ''} />
        </div>
    );
});

export default LetterBox;
